<template>
    <div>
        <div class="product">
            <div class="columns is-centered">
                <div class="column is-narrow">
                    <img onerror="this.style.display='none'" v-for="img in images" class="img" :src="img" >
                </div>
            </div>
        </div>
        <DownloadBrochure></DownloadBrochure>
    </div>
</template>

<script>
    import DownloadBrochure from "./DownloadBrochure";
    export default {
        name: "imgLoader",
        components: {DownloadBrochure},
        props: ['src'],
        data() {
            return {
                images: []
            }
        },
        mounted() {
            const numImg = 15;
            let i = 1;
            do {
                let imgSrc = 'img/' + this.src + '/' + i + '.svg';
                this.images.push(imgSrc);
                i++
            } while (i !== numImg + 1)
        }
    }
</script>

<style scoped>
    .product {
        padding-left: 4%;
        padding-right: 4%;
        padding-top: 72px;
        padding-bottom: 72px;
    }

    .img {
        display: block;
        width: 540px;
        margin-bottom: 36px;
    }
</style>